export const facebookLogo: string = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4408_12660)">
<path d="M12 24.0017C18.6274 24.0017 24 18.6291 24 12.0017C24 5.37429 18.6274 0.00170898 12 0.00170898C5.37258 0.00170898 0 5.37429 0 12.0017C0 18.6291 5.37258 24.0017 12 24.0017Z" fill="#1977F3"/>
<path d="M16.6712 15.4713L17.2028 12.0017H13.875V9.75057C13.875 8.80218 14.3391 7.87573 15.8308 7.87573H17.3445V4.92255C17.3445 4.92255 15.9709 4.68799 14.658 4.68799C11.9175 4.68799 10.1253 6.34851 10.1253 9.35737V12.0017H7.07764V15.4713H10.1253V23.8566C10.7362 23.9528 11.3623 24.0017 12.0002 24.0017C12.638 24.0017 13.2641 23.9511 13.875 23.8566V15.4713H16.6712Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4408_12660">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;
